<div class="user-admin-wrapper">
    <app-language-chooser></app-language-chooser>
    @if(user) {
       <!-- <button mat-icon-button (click)="showAside()"><mat-icon  aria-hidden="false" fontIcon="notifications"></mat-icon></button>-->
        @if(user && user.effectiveRoles.ROLE_ASSET_CREATE) {
            <button mat-raised-button class="me-4" (click)="openUpload()"><mat-icon fontIcon="upload_file"></mat-icon>{{'nav.upload'| translate}}</button>
        }

        <button [matMenuTriggerFor]="menu" mat-icon-button [matTooltip]="user.firstName + ' ' + user.lastName" ><mat-icon>person</mat-icon></button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editUser()">{{'menu.editprofile' | translate}}</button>
            @if(user && user.effectiveRoles.ROLE_ADMIN_ACCESS) {
                <button mat-menu-item (click)="mangeUsers()">{{'menu.manageUsers' | translate}}</button>
            }
            <button mat-menu-item (click)="logout()">{{'menu.logout' | translate}}</button>
           <!-- <button [matMenuTriggerFor]="subMenu" mat-menu-item>Item 2</button>-->
        </mat-menu>
        <mat-menu #subMenu="matMenu" xPosition="before">
            <div mat-menu-item>
                <div class="row">
                    <div class="col-6">
                        <ul><li><div>humse dumse</div></li>
                            <li>ho</li></ul>
                    </div>
                    <div class="col-6">
                        <ul><li>hu</li>
                            <li>ho</li>
                            <li>ho</li>
                        </ul>
                    </div>
                </div>
            </div>
            <button mat-menu-item>Item 2</button>
        </mat-menu>

    } @else {
        <button mat-raised-button (click)="login()"><mat-icon  aria-hidden="false" fontIcon="login"></mat-icon>{{'button.login' | translate}}</button>
    }

</div>
